import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";

import Editor from "editor/components/Editor";
import Rubric from "editor/components/Rubric";
import HeadlineInput from "editor/components/HeadlineInput";
import EmbedEditor from "editor/containers/EmbedEditor";
import LinkEditor from "editor/components/LinkEditor";
import PrimaryImage from "editor/components/PrimaryImage";
import InstoryNewsletterCTA from "editor/components/InstoryNewsletterCTA";

import { onChange, updateEditor, validateFormAsync } from "editor/actions/form";
import {
  handleKeyCommand,
  handleReturn,
  handlePastedText,
  onTab,
} from "editor/actions/editor";

import getActiveEditorState from "editor/utils/getActiveEditorState";

import styles from "./StoryEditor.css";
import {
  STORY_PLACEHOLDER,
  FACTS_MATTER_PLACEHOLDER,
  TEMPLATES,
} from "config/constants/editor";

class StoryEditor extends React.Component {
  constructor(props) {
    super(props);
    this.onContentChange = this.props.updateEditor("content");
  }

  render() {
    const placeholder =
      this.props.editorForm.template &&
      this.props.editorForm.template.id === TEMPLATES.FACTS_MATTER.id
        ? FACTS_MATTER_PLACEHOLDER
        : STORY_PLACEHOLDER;

    return (
      <div className={styles.root}>
        <div className={styles.top}>
          <div className={styles.container}>
            <Rubric
              rubric={this.props.editorForm.rubric}
              template={this.props.editorForm.template}
            />
            <HeadlineInput
              value={this.props.editorForm.headline}
              onChange={this.props.onChange("headline")}
              isDisabled={this.props.status.isReadOnly}
              error={this.props.editorForm.errors.headline}
            />
          </div>
          <PrimaryImage
            getBaseUrl={this.props.getBaseUrl}
            primaryImage={this.props.editorForm.primary_image}
            formPath="primary_image"
            handleKeyCommand={this.props.handleKeyCommand}
          />
          <div className={styles.container}>
            <LinkEditor />
            <EmbedEditor />
            <Editor
              onChange={this.onContentChange}
              editorState={this.props.editorForm.content}
              handleKeyCommand={this.props.handleKeyCommand}
              handleReturn={this.props.handleReturn}
              handlePastedText={this.props.handlePastedText}
              onTab={this.props.onTab}
              readOnly={this.props.status.isReadOnly}
              placeholder={placeholder}
              template={this.props.editorForm.template}
              primaryImage={this.props.editorForm.primary_image}
              contentType={this.props.match.params.type}
              isDisabled={this.props.status.isReadOnly}
              error={this.props.editorForm.errors.body}
            />
          </div>
          {this.props.editorForm.promotion && (
            <div className={styles.container}>
              <InstoryNewsletterCTA
                promotion={this.props.editorForm.promotion}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    editorForm: state.editor.form,
    activeEditor: getActiveEditorState(state),
    status: state.editor.status,
  };
};

const mapDispatchToProps = {
  validateFormAsync,
  updateEditor,
  handleKeyCommand,
  onTab,
  onChange,
  handleReturn,
  handlePastedText,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(StoryEditor)
);

StoryEditor.propTypes = {
  validateFormAsync: PropTypes.func.isRequired,
  updateEditor: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  editorForm: PropTypes.object.isRequired,
  handleKeyCommand: PropTypes.func.isRequired,
  handleReturn: PropTypes.func.isRequired,
  handlePastedText: PropTypes.func.isRequired,
  onTab: PropTypes.func.isRequired,
  getBaseUrl: PropTypes.func.isRequired,
  status: PropTypes.object.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
};
